import mongoose from "mongoose";

export enum FeedbackType {
    Bug = "bug",
    Suggestion = "suggestion",
    Other = "other",
    RecommendOrganization = "recommend organization",
}

export enum FeedbackStatus {
    New = "new",
    Planned = "planned",
    Incorporated = "incorporated",
    Rejected = "rejected",
}

export interface Feedback {
    feedbackid: string;
    title: string;
    description: string;
    type: FeedbackType;
    pageTriggered: string;
    submissionDate: Date;
    status: FeedbackStatus;
    userId?: mongoose.Types.ObjectId;
    requestingFor?: string;
}
